// 日本語 language pack
export default {
  __meta: { code: 'ja-JP', label: '日本語', short: '日' },

  common: {
    yes: 'はい',
    no: 'いいえ',
    cancel: 'キャンセル',
    confirm: '確認',
    save: '保存',
    submit: '送信',
    loading: '読み込み中…',
    retry: '再試行',
    back: '戻る',
    next: '次へ',
    prev: '前へ',
    search: '検索',
    filter: 'フィルター',
    sort: '並び替え',
    all: 'すべて',
    more: 'もっと見る',
    less: '閉じる',
    close: '閉じる',
    edit: '編集',
    delete: '削除',
    copy: 'コピー',
    share: '共有',
    minutesAgo: '{n}分前',
    hoursAgo: '{n}時間前',
    daysAgo: '{n}日前',
    online: 'オンライン',
    offline: 'オフライン'
  },

  nav: {
    home: 'ホーム',
    problems: '問題',
    teams: 'チーム',
    leaderboard: 'ランキング',
    chain: 'チェーン',
    academy: 'アカデミー',
    videos: 'HPハッカソン',
    login: 'ログイン',
    register: '登録',
    logout: 'ログアウト',
    profile: 'プロフィール',
    language: '言語'
  },

  home: {
    title: 'AIで世界{count}の最も難しい{n}問を解く',
    subtitle: 'リーマンから室温超伝導まで、意識から核融合まで',
    desc: '誰でもAIで挑戦できます。すべての解答に{reward}。',
    reward: 'オンチェーンHPWポイント',
    cta: '解き始める →',
    ctaLeaderboard: 'ランキング',
    statsProblems: '問題',
    statsSolved: '解答',
    statsUsers: '解答者',
    statsRewards: 'HPW配布済み',
    categories: '{n}つの分野',
    categoriesDesc: '分野を選んで、人類がまだ解いていない問題を見てみよう',
    viewAll: 'すべての問題 →',
    liveOnChain: 'オンチェーン{txs}件 · {blocks}ブロック'
  },

  problems: {
    title: 'すべての難問',
    subtitle: '8つの分野にわたる{n}の挑戦',
    searchPlaceholder: '問題、タグ、キーワードを検索…',
    filterCategory: 'カテゴリー',
    filterStatus: 'ステータス',
    statusAll: 'すべて',
    statusOpen: '未解決',
    statusPartial: '部分解決',
    statusSolved: '解決済み',
    difficulty: '難易度',
    reward: '報酬',
    solutions: '解答',
    votes: 'ネット投票',
    tags: 'タグ',
    year: '年',
    proposer: '提案者',
    empty: '条件に一致する問題がありません'
  },

  problem: {
    back: '← 問題一覧に戻る',
    info: '情報',
    kidExplain: '子ども向け説明',
    formalStatement: '厳密な記述',
    whyHard: 'なぜ難しいか',
    howToEarn: 'ポイントの獲得方法',
    earnSubmit: '解答を送信: +{n} HPW',
    earnAi: 'AIスコア ≥ {n}: 1点ごとに +{m} HPW',
    earnVote: '高評価(各): 著者に +{n} HPW',
    earnFullSolve: '完全解決: 最大 {n} HPW',
    earnRule: 'すべてのポイントは5秒で自動ステーキング。永続的にオンチェーン。',
    aiSolver: 'AIアシスタント',
    aiSolverDesc: 'AIにあなたの視点を伝えてください。3層構造で回答: 入門 → 学術 → 研究の方向性。',
    aiUsingLLM: '実LLM使用',
    aiFallback: 'ヒューリスティック',
    userInputPlaceholder: '(任意) 例で説明?',
    runAi: 'AIに聞く',
    noSolution: 'まだ解答がありません。最初の一人になろう!',
    submitSolution: '解答を送信',
    submittedBy: 'by {user}',
    quality: 'AIスコア',
    selfTest: '私の解答',
    openChat: 'AI アシスタントを開く',
    inputPlaceholder: 'AI に具体的な質問をする…',
    continueChat: '対話を続ける（{n} メッセージ）',
    openAI: '💬 AI アシスタントを開く'
  },

  submit: {
    title: '私の解答',
    contentPlaceholder: 'あなたの考えを書いてください。最低20文字。構造が良いほど高得点。',
    tooShort: '解答が短すぎます(最低20文字)',
    submitted: '送信しました!',
    submitFailed: '送信失敗: {msg}'
  },

  leaderboard: {
    title: 'ランキング',
    subtitle: 'オンチェーンHPWで並び替え。5秒ごとに新しいブロック。',
    solvers: '解答者',
    solutions: '総解答数',
    txOnChain: 'オンチェーンTX',
    height: 'チェーン高',
    rewardsPaid: '配布済み報酬',
    rank: '順位',
    score: 'ポイント',
    badges: 'バッジ',
    badgesTitle: '{n}段階のチャレンジバッジ'
  },

  chain: {
    title: 'ブロックチェーンエクスプローラー',
    subtitle: 'すべてのポイント取引は不変的にオンチェーン。ブロックをクリックして詳細を見る。',
    height: '高さ (ブロック)',
    totalTxs: '総TX数',
    totalSupply: '総供給量 (HPW)',
    valid: '有効',
    invalid: '無効',
    selectBlock: '左側のブロックをクリックして取引を表示',
    latestBlocks: '最新ブロック',
    latestTxs: '最新TX',
    txId: 'TX ID',
    type: 'タイプ',
    to: '送信先',
    amount: '金額',
    time: '時刻',
    empty: 'データなし'
  },

  auth: {
    title: '難問に参加',
    subtitle: 'アカウントを作成して解き始めよう',
    username: 'ユーザー名',
    usernameHint: '2-30文字、英数字、_, CJK, -',
    password: 'パスワード',
    passwordHint: '6-200文字',
    bio: '自己紹介 (任意)',
    bioHint: '最大200文字',
    register: '登録',
    login: 'ログイン',
    switchToLogin: 'アカウントをお持ちですか? ログイン',
    switchToRegister: 'アカウントがない? 登録',
    welcome: '登録で100 HPWボーナス',
    errUsername: 'ユーザー名は2-30文字',
    errPassword: 'パスワードは6-200文字',
    errTaken: 'ユーザー名は使用中',
    errWrong: 'ユーザー名またはパスワードが間違っています'
  },

  // Collaboration (v1.4.0)
  collab: {
    discussions: 'ディスカッション',
    roadmap: 'ロードマップ',
    teams: 'チーム',
    teamsSubtitle: '同志と一緒にチームを組み、貢献を集約し、スコアを共有する。',
    teamsFor: 'この問題のチーム',
    teamsCount: 'チーム',
    selectProblem: '問題を選択',
    chooseProblem: '問題を選んでください',
    pickProblemFirst: '上部の問題を選んでチームを表示または作成',
    startDiscussion: '新しいディスカッションを開始…',
    post: '投稿',
    reply: '返信',
    replyPlaceholder: '返信を書く…',
    upvote: '高評価',
    downvote: '低評価',
    edited: '編集済み',
    noDiscussions: 'ディスカッションはまだありません — 始めよう！',
    loginRequired: 'まずログインしてください',
    loginToDiscuss: 'ディスカッションに参加するにはログイン',
    loginToContribute: 'ロードマップを追加するにはログイン',
    confirmDelete: '削除してもよろしいですか？元に戻せません。',
    roadmapSubtitle: '研究の進捗を記録：提案、調査中、進行中、突破、ブロック、完了',
    roadmapTitlePlaceholder: '進捗タイトル',
    roadmapDescPlaceholder: '任意の説明',
    addEntry: 'エントリーを追加',
    noRoadmap: 'まだロードマップはありません',
    createTeam: 'チームを作成',
    teamNamePlaceholder: 'チーム名（問題ごとに一意）',
    teamDescPlaceholder: 'チームの説明（任意）',
    create: '作成',
    noTeamsYet: 'まだチームはありません',
    beFirstToCreate: '最初の一人になろう！',
    leader: 'リーダー',
    member: 'メンバー',
    members: 'メンバー',
    joinTeam: 'チームに参加',
    confirmLeave: 'このチームを退出しますか？',
    confirmDisband: 'このチームを解散しますか？元に戻せません！',
    disband: '解散',
    leaveTeam: '退出',
    contributions: 'メンバーの貢献',
    noContributions: 'まだ貢献はありません',
    solutions: '解答数',
    score: 'スコア',
    teamNotFound: 'チームが見つからないか既に解散済み',
    backToTeams: 'チーム一覧に戻る',
    youAreLeader: 'あなたはリーダーです',
    youAreMember: 'あなたはメンバーです'
  },

  notFound: {
    title: '404 — ページが見つかりません',
    desc: 'お探しのページは存在しないか、まだインデックスされていません。{n}問の難問を見てみませんか?',
    home: '← ホーム',
    browse: '問題を閲覧',
    rank: 'ランキング'
  },

  pwa: {
    install: 'HardProblemsをデバイスにインストール',
    installShort: 'インストール',
    update: '新しいバージョンが利用可能',
    updateNow: '今すぐ更新',
    offline: 'オフライン · 一部機能利用不可'
  },

  categories: {
    mathematics: '数学',
    physics: '物理学',
    chemistry: '化学',
    biology: '生命科学',
    cs: '情報科学',
    philosophy: '哲学',
    engineering: '工学',
    social: '社会科学'
  },

  // Hardcoded strings extracted from JSX
  hardcoded: {

  },

  // Hardcoded strings extracted from JSX
  hardcoded: {
    hc_87285292: '🎖 チャレンジャーメダル',
    hc_38149815: '📦 最新のブロック',
    hc_48616739: 'ブロックはまだありません',
    hc_57878265: '📨 最新の取引',
    hc_63698773: 'トランザクションID',
    hc_1714432: 'タイプ',
    hc_76617209: '受信側',
    hc_86455028: '金額',
    hc_45733203: '日時',
    hc_4062857: 'まだトランザクションはありません',
    hc_15614928: '取引の詳細',
    hc_12461780: 'なし（ジェネシスブロック）',
    hc_36065070: '読み込み中…',
    hc_39726153: 'ユーザーは存在しません',
    hc_65423691: '次のメダル：',
    hc_65829733: 'HPW残高',
    hc_33844058: '回答数',
    hc_34880504: 'オンチェーン取引',
    hc_64546944: '累計獲得額',
    hc_63635099: '🔑 ブロックチェーンウォレットアドレス',
    hc_92114295: '解答',
    hc_12374108: '📨 オンチェーン録画',
    hc_38642490: 'オンチェーン取引はまだありません',
    hc_39272624: 'すべての難しい質問',
    hc_72504969: 'オンチェーン',
    hc_76554194: 'トランザクション·',
    hc_13199282: '問題解決者',
    hc_49455724: '解決',
    hc_15553251: '世界で最も難しいこと',
    hc_73115764: '質問',
    hc_58891330: 'リーマン仮説から室温の超電導、意識の本質から核融合まで。',
    hc_11135829: 'オンチェーンHPWポイント報酬',
    hc_14271420: '動画番号検索',
    hc_93127099: '「HPハッカソン」',
    hc_95444243: '・毎日1分間好奇心を燃やす・WeChat検索とフォロー',
    hc_48803929: 'WeChatで「HPハッカソン」を検索・1日1分で好奇心を刺激',
    hc_4038150: '問題が存在しません',
    hc_1415707: '質問リスト←に戻る',
    hc_3109735: '参加するに🙋はどうすればよいですか？',
    hc_24717615: '専門家である必要はありません。次のいずれかの方法でこれを支援できます。',
    hc_6216823: 'AIに聞く',
    hc_49022408: '、または',
    hc_72042925: 'ランキング',
    hc_60372142: '💬 AIアシスタント・複数会話',
    hc_98658150: 'キッズエディション',
    hc_11457022: '厳格ステートメント',
    hc_53488: 'なぜ難しいのですか？',
    hc_24903028: '🌀 考えています...',
    hc_67511018: 'AIベースのコンテンツを変更して送信すると、「AIアシスト」としてマークされます',
    hc_74081354: '回答✍️ を送信してください',
    hc_8743312: '5次元評価',
    hc_79230102: '正常に✅送信されました！',
    hc_9486386: '獲得',
    hc_10506083: 'ブロックチェーン',
    hc_60763393: 'チームで答え🤝を探してみませんか？',
    hc_817654: '質問チームページ',
    hc_91839987: '📋 質問のメタ情報',
    hc_7972472: '提出年',
    hc_4585175: '提出者',
    hc_49772229: '難易度',
    hc_6351505: 'コンディション',
    hc_77609957: '基本報酬',
    hc_59943341: 'ポイントを獲得💰するにはどうすればよいですか？',
    hc_1469249: '・回答を送信する：',
    hc_66284549: '・AIスコア≥ 60 ：',
    hc_29791639: '・いいね（ 1人1回あたり） ：',
    hc_97186354: '作成者のHPW +5',
    hc_18280432: '・パズルを解く：',
    hc_76767612: 'すべてのポイントは5秒以内に自動的に巻かれ、永久に表示されます。',
    hc_55655280: 'この難しい質問🌟を共有する',
    hc_9145530: '優位性：',
    hc_9755158: 'る 決',
    hc_78448776: '🤖 AIアシスト',
    hc_99426362: '💬 AIアシスタント',
    hc_40752456: 'AIはこの質問のすべてのコンテキストを読みました。質問を始めましょう ↓',
    hc_67183189: 'AIは考えています...',
    hc_38124998: '送信する',
    hc_34225746: 'エラーが発生しました',
    hc_29662853: 'チェーンの高さ',
    hc_84566882: 'ブロック:',
    hc_41149725: '取引',
  }
};
